import { useState, useEffect } from 'react';
import logo from '../images/logo.png';
import { links } from '../data/dataNav';
import { Link } from 'react-router-dom';
import { HiMenuAlt2 } from 'react-icons/hi';
import Sidebar from './Sidebar';
const Navbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const closeSidebar = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    if (showSidebar) {
      document.body.style.overflow = 'hidden';
    } else document.body.style.overflow = 'unset';
  }, [showSidebar]);

  const [lastScrollY, setLastScrollY] = useState(0);
  const [showNavbar, setShowNavbar] = useState(true);

  const handleScroll = () => {
    if (window.scrollY > lastScrollY) {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }

    setLastScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);
  return (
    <>
      <Sidebar showSidebar={showSidebar} closeSidebar={closeSidebar} />
      <header className={`${showNavbar ? 'showNav' : 'hideNav'}`}>
        <section className="navbar">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="logo" />
              <h2>Kwiecińscy</h2>
            </Link>
          </div>
          <button className="nav-toggle" onClick={() => setShowSidebar(true)}>
            <HiMenuAlt2 />
          </button>
          <ul className="nav-links">
            {links.map((link) => {
              return (
                <li key={link.id}>
                  {link.text !== 'Kontakt' ? (
                    <Link to={link.url}>{link.text}</Link>
                  ) : (
                    <a href={link.url}>{link.text}</a>
                  )}
                </li>
              );
            })}
          </ul>
        </section>
      </header>
    </>
  );
};

export default Navbar;
